Lesson = require '../../../models/lesson'

start_time = null

open = ->
  start_time = Date.now()

  lesson = new Lesson()
  lesson.load (err, lessonData) ->
    initOptions = {
      preventLogoutOnExit: !!lessonData?.config?.preventLogoutOnExit
    }

    pipwerks.SCORM.init(initOptions)

padLeft = (val = "", length) ->
  str = ""
  vl = val.toString().length
  if (vl >= length)
    val
  else
    l = length - vl + 1
    (new Array(l).join("0")).substr(0, (length - vl)) + val

setSessionTime = ->
  end_time = Date.now()

  # session_time in seconds
  session_time = Math.floor((end_time - start_time) / 1000)

  hours = Math.floor(session_time / 3600)
  session_time -= hours * 3600

  minutes = Math.floor(session_time / 60)
  session_time -= minutes * 60

  # as hours and minutes were removed from session_time, only seconds are left in there.
  seconds = Math.floor(session_time)

  # 1. Get total milliseconds: end_time - start_time.
  # 2. As hours,minutes,seconds are already computed, take only last 3 digits (millis): % 1000
  # 3. Remove last digit as we need only 2 digits, not 3: / 10
  milliseconds = (end_time - start_time) % 1000
  milliseconds_rounded = Math.floor(milliseconds / 10)

  session_time = [padLeft(hours, 4),
    padLeft(minutes, 2),
    padLeft(seconds, 2)].join(":")

  session_time = session_time + '.' + padLeft(milliseconds_rounded, 2)

  pipwerks.SCORM.set("cmi.core.session_time", session_time)

complete = ->
  setSessionTime()
  lesson = new Lesson()
  lesson.load (err, lessonData) ->
    if lessonData
      {minimumScore, incompleteOnFail} = lessonData.config or {}
      Application.actions("Analytics")
        .trackScoreAndCompletion(minimumScore, incompleteOnFail)
    else
      console.error "Error loading lesson data", err

    # If SCORM.quit() is called, the lesson exits even when the exit Button is enabled
    if lessonData.config.hasScormExitButton
      pipwerks.SCORM.save()
    else
      setSessionTime()
      pipwerks.SCORM.save()
      pipwerks.SCORM.quit()

exit = ->
  setSessionTime()
  pipwerks.SCORM.quit()

commands = (next) -> {complete, open, exit}

module.exports = {type: "lesson", commands}
